<template>
    <DefaultLayout header="primary" footer="primary" :isStaticPage="isStaticPage">
        <div v-if="pageData">
            <Component v-if="isComponentRegistered(componentName)" :is="componentName" />

            <div v-else>
                <ContentHeroBanner :title="pageData.title" :subtitle="pageData.page_sub_title" />
                <div class="container my-4">
                    <div class="row">
                        <div class="col-12 content-page">
                            <div class="heading-container d-flex">
                                <h1 class="d-flex">{{ pageData.heading }}</h1>
                                <div class="date-container d-flex">
                                    <span v-if="formatedUpdatedAt" class="d-flex"
                                        >{{ $t('contentPages.updatedOn') }} {{ formatedUpdatedAt }}</span
                                    >
                                </div>
                            </div>
                            <div v-html="pageData.content"></div>
                        </div>
                    </div>
                </div>
            </div>

            <PrivacyOptOut v-if="pageData.template == 'privacy_policy' && pageData.hide_preference_widget !== 1" />
        </div>
    </DefaultLayout>
</template>

<script>
import { useStore } from 'vuex'
import { resolveDynamicComponent } from 'vue'

// lodash components
import forEach from 'lodash/forEach'
import split from 'lodash/split'
import startsWith from 'lodash/startsWith'
import camelCase from 'lodash/camelCase'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    created() {
        this.emitter.on('pageData:loaded', () => {
            // Listen for loaded event once
            this.emitter.off('pageData:loaded')

            this.$nextTick(() => {
                const tags = document.getElementsByTagName('a')

                forEach(tags, tag => {
                    if (tag.hash) {
                        tag.addEventListener('click', this.clickScroll, false)
                    }
                })

                setTimeout(() => {
                    this.scrollTo(window.location.hash)
                }, 1000)
            })
        })
    },
    methods: {
        clickScroll: function (event) {
            const target = event.target.tagName === 'A' ? event.target : event.target.parentElement

            // If the hash is NOT on this page, do not prevent default
            if (!startsWith(target.href, window.location.origin + window.location.pathname)) {
                return
            }

            event.preventDefault()

            this.scrollTo(target.hash)
        },
        scrollTo: function (selector) {
            selector = decodeURI(split(selector, '#')[1])

            let element = document.getElementById(selector)
            // We commonly have questions as anchors,
            // browsers strip out the question mark,
            // so let's try with the ? if no element is found
            if (!element) {
                element = document.getElementById(selector + '?')
            }

            if (element) {
                element.scrollIntoView({ behavior: 'smooth' })
            }
        },
        isComponentRegistered(componentName) {
            if (componentName == 'contentPage') {
                return false
            }

            const component = resolveDynamicComponent(componentName)
            return typeof component === 'object'
        },
    },
    computed: {
        pageData: function () {
            if (this.store.state.global.page) {
                this.emitter.emit('pageData:loaded')

                return this.store.state.global.page
            }

            return null
        },
        componentName: function () {
            if (this.pageData.template) {
                return camelCase(this.pageData.template)
            }

            return false
        },
        isStaticPage: function () {
            return this.pageData.template === 'static_offer_page' || this.pageData.template === 'static_accept_page'
        },
        territory: function () {
            return window.TERRITORY
        },
        formatedUpdatedAt: function () {
            if (!this.pageData) return null

            let date = new Date(this.pageData.updated_at.replace(/-/g, '/').substring(0, 10))

            const options = {
                day: '2-digit',
                year: 'numeric',
                month: 'long',
            }

            date = Intl.DateTimeFormat(this.$t('locale'), options).format(date)

            return date
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.content-page {
    table {
        width: 100% !important;

        td {
            padding: 10px;
        }
    }
    .heading-container {
        margin-bottom: 32px;
        flex-wrap: wrap;
        justify-content: center;

        @media screen and (min-width: $bp-large) {
            justify-content: space-between;
        }

        h1 {
            font-size: rem(32px);
            font-weight: 700;
            margin-bottom: 17px;

            @media screen and (min-width: $bp-large) {
                margin-bottom: 0px;
            }
        }

        .date-container {
            justify-content: center;
            width: 100%;

            span {
                align-self: end;
                color: #808080;
                font-size: rem(14px);
            }

            @media screen and (min-width: $bp-large) {
                width: initial;
            }
        }
    }

    h2 {
        font-size: rem(30px);
        margin-bottom: 16px;

        a {
            font-size: rem(30px);
        }
    }

    p,
    li {
        color: #242a2f;
        font-size: rem(14px);
        letter-spacing: -0.01em;
        line-height: 120%;
    }

    a {
        color: var(--primary);
        font-family: var(--primary-font);
        font-size: rem(14px);
        font-weight: 600;
    }
}
</style>
